/**
 * The sign-in methods a product offers beside Google and the email link, which every product has.
 * Each product's config carries a `signIn` entry of this shape; a method is offered only when its
 * product turns it on AND the task holds its credentials (signInMethods.server.ts), so turning one
 * on before its secrets are in place offers nothing rather than a broken button.
 */
export type SignInMethods = {
    /** Facebook Login: a button beside Google's, and a way to sign in from inside the Meta apps. */
    facebook: boolean
    /** Google One Tap: Google's own prompt over any page, for a visitor signed in to Google. */
    googleOneTap: boolean
}

/** What the root loader hands the browser: which buttons to draw, and One Tap's public client id. */
export type PublicSignIn = {
    facebook: boolean
    googleOneTapClientId: string | null
}

/** The `trigger` a One Tap sign-in carries, from the tap (auth_option_selected) to its landing (sign_up/sign_in). */
export const GATE_TRIGGER_ONE_TAP = 'one-tap'
